export const getSplittedToolCatalogName = (name: string): { title: string; subTitle?: string | null } => {
  // Use regular expression to find the first integer or abbreviation
  const match = name.match(/(\d+|\b[A-Z][A-Z]+\b)/);
  // Check if a match is found
  if (match && match.index) {
    // Extract the index of the first integer or abbreviation
    const index = match.index;

    // Extract title and subtitle
    const title = name.substring(0, index);
    const subTitle = name.substring(index);
    return { title, subTitle };
  } else {
    return { title: name,subTitle:'' };
  }
};
